import { ExtractionStatus } from "@inrev/common";
import type { SortingState } from "@tanstack/react-table";
import { useMemo } from "react";
import { DynamicDataTable } from "../../../../ui/DynamicDataTable/DynamicDataTable";
import {
	createWipReviewQueueColumns,
	type WipReviewQueueColumnsConfig,
} from "./WipReviewQueueColumns";
import type { WipReviewQueueRow } from "./wipReviewQueueRow";

export const ADMIN_ACCOUNT_WIP_REVIEW_QUEUE_TABLE_NAME = "admin_account_wip_review_queue_v1";

const WIP_REVIEW_QUEUE_INITIAL_SORTING: SortingState = [{ id: "uploadedAt", desc: true }];

export function disableWipReviewQueueRowClick(row: WipReviewQueueRow): boolean {
	return row.status !== ExtractionStatus.Completed && row.status !== ExtractionStatus.Partial;
}

function wipReviewQueueRowLabel(row: WipReviewQueueRow): string {
	return `Review ${row.attachment.file.name}`;
}

export type WipReviewQueueTableProps = {
	data: WipReviewQueueRow[];
	columnConfig: WipReviewQueueColumnsConfig;
	onRowClick: (row: WipReviewQueueRow) => void;
};

export function WipReviewQueueTable({ data, columnConfig, onRowClick }: WipReviewQueueTableProps) {
	const columns = useMemo(() => createWipReviewQueueColumns(columnConfig), [columnConfig]);

	return (
		<DynamicDataTable
			name={ADMIN_ACCOUNT_WIP_REVIEW_QUEUE_TABLE_NAME}
			columns={columns}
			data={data}
			initialSorting={WIP_REVIEW_QUEUE_INITIAL_SORTING}
			onRowClick={onRowClick}
			disableRowClick={disableWipReviewQueueRowClick}
			rowLabel={wipReviewQueueRowLabel}
			tableClassName="border-0 rounded-none"
		/>
	);
}
